import CRMClients from "./crm-component/CRMClients";

export default function CRM(){
    return(
     <>
      <CRMClients/>
     </>
    )
}